import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ISearchState {
  token: string | null
  pageSize: number
  currentPage: number
  selectedDates: Date[]
  selectedStatuses: string[]
}

const initialState: ISearchState = {
  token: null,
  pageSize: 10,
  currentPage: 1,
  selectedDates: [],
  selectedStatuses: []
}

const userSearch = createSlice({
  name: 'userSearch',
  initialState,
  reducers: {
    setSearchToken: (state, action: PayloadAction<ISearchState>) => {
      state.token = action.payload.token
      state.pageSize = action.payload.pageSize
      state.currentPage = action.payload.currentPage
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setSelectedDates: (state, action: PayloadAction<Date[]>) => {
      state.selectedDates = action.payload
      state.currentPage = 1
    },
    setSelectedStatuses: (state, action: PayloadAction<string[]>) => {
      state.selectedStatuses = action.payload
      state.currentPage = 1
    },
    clearSearchToken: () => {
      return {
        ...initialState
      }
    }
  }
})

export const { setSearchToken, clearSearchToken, setCurrentPage, setSelectedDates, setSelectedStatuses } = userSearch.actions
export const searchUserReducer = userSearch.reducer
